import moment from 'moment';

export const Columns = {
  Quantity: {
    name: 'Quantity',
    altSrc: 'Sort By Quantity',
    getData: (stock) => stock.units_in_stock,
  },
  Sold: { name: 'Sold', altSrc: 'Sort By Sold', getData: (stock) => stock.sold_last_30_days },
  Used: { name: 'Used', altSrc: 'Sort By Used', getData: (stock) => stock.used_last_30_days },
  RetailPrice: {
    name: 'Retail Price',
    altSrc: 'Sort By Price',
    getData: (stock) => stock.price,
  },
  CostPrice: {
    name: 'Cost Price',
    altSrc: 'Sort By Cost Price',
    getData: (stock) => stock.cost_price,
  },
  TotalPrice: {
    name: 'Total Cost',
    altSrc: 'Sort By Total Cost',
    getData: (stock) => (Math.max(0, stock.units_in_stock) * Number(stock.cost_price)).toFixed(2),
  },
  UsedOverTime: {
    name: 'Used',
    altSrc: 'Sort By Used over the period',
    getData: (stock) => (stock.usedSoldInRangeData ? stock.usedSoldInRangeData.used : 0),
  },
  SoldOverTime: {
    name: 'Sold',
    altSrc: 'Sort By Sold over the period',
    getData: (stock) => (stock.usedSoldInRangeData ? stock.usedSoldInRangeData.sold : 0),
  },
  Cost: {
    name: 'Cost',
    altSrc: 'Sort By Cost',
    getData: (stock) => (stock.usedSoldInRangeData ? parseFloat((stock.usedSoldInRangeData.sold + stock.usedSoldInRangeData.used) * Number(stock.cost_price)).toFixed(2) : 0),
  },
  RevenueForRange: {
    name: 'Revenue',
    altSrc: 'Sort By Revenue',
    getData: (stock) => (stock.revenueForRange ? stock.revenueForRange.total.toFixed(2) : 0),
  },
  LastChangeDate: {
    name: 'Last Change Date',
    altSrc: 'Sort by timestamp',
    getData: (stock) => (stock.latest_change.timestamp ? moment(stock.latest_change.timestamp).format('DD-MM-YYYY') : 0),
  },
  LastChangeAmount: {
    name: 'Amount of last change',
    altSrc: 'Sort By last change amount',
    getData: (stock) => (stock.latest_change.amount ? stock.latest_change.amount : 0),
  },
  LastChangeType: {
    name: 'Type of last change',
    altSrc: 'Sort By type of last change',
    getData: (stock) => {
      switch (stock.latest_change.type) {
        case 'void':
          return 'Void';
        case 'inventory_counting':
          return 'Adjusted';
        case 'sale':
          return 'Sold';
        case 'used':
          return 'Used';
        case 'delivery':
          return 'New in';
        default:
          return stock.latest_change.type;
      }
    },
  },
};

// The "Name" Column is by default first in every page
export const ColumnsOrder = {
  ManagerLayoutColumnsOrder: [Columns.Sold], // [Columns.Quantity, Columns.Sold, Columns.Used, Columns.RetailPrice],
  StockHoldingColumnsOrder: [Columns.Quantity, Columns.Sold], // [Columns.CostPrice, Columns.TotalPrice],
  UsedSoldOverDateRange: [Columns.Quantity, Columns.UsedOverTime, Columns.SoldOverTime, Columns.Cost, Columns.RevenueForRange],
  LastStockMovement: [Columns.Quantity, Columns.LastChangeDate, Columns.LastChangeAmount, Columns.LastChangeType],
};

export const ManagerLayoutColumnsOrder = [Columns.Quantity, Columns.Sold, Columns.Used, Columns.RetailPrice];
export const StockHoldingColumnsOrder = [Columns.Quantity, Columns.CostPrice, Columns.TotalPrice];
export const UsedSoldOverDateRange = [Columns.Quantity, Columns.UsedOverTime, Columns.SoldOverTime, Columns.Cost, Columns.RevenueForRange];
export const LastStockMovement = [Columns.Quantity, Columns.LastChangeDate, Columns.LastChangeAmount, Columns.LastChangeType];

export const STOCK_MANAGER_PDF_TABLE_ID = 'tableManager';
export const STOCK_SOLD_PDF_TABLE_ID = 'tableSold';
export const STOCK_HOLDING_PDF_TABLE_ID = 'tableHolding';
export const STOCK_LAST_MOVEMENT_PDF_TABLE_ID = 'tableLastMovement';
export const STOCK_ORDERING_PDF_TABLE_ID = 'stock-ordering-table';
